module.exports = __webpack_public_path__ + "img/travelCard1.28070e27.png";